"use strict";
(self["webpackChunkubco"] = self["webpackChunkubco"] || []).push([[233],{

/***/ 9685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-484b71e6] {\n  will-change        : height, padding-top, padding-bottom, margin-top, margin-bottom, opacity;\n  transform          : translateZ(0);\n  backface-visibility: hidden;\n  perspective        : 1000px;\n}\n.expand-enter-active[data-v-484b71e6],\n.expand-leave-active[data-v-484b71e6] {\n  transition: height .2s ease-in-out,\n              padding-top .2s ease-in-out,\n              padding-bottom .2s ease-in-out,\n              margin-top .2s ease-in-out,\n              margin-bottom .2s ease-in-out,\n              opacity .2s ease-in-out;\n  overflow  : hidden;\n}\n.expand-enter[data-v-484b71e6],\n.expand-leave-to[data-v-484b71e6] {\n  height        : 0;\n  padding-top   : 0;\n  padding-bottom: 0;\n  margin-top    : 0;\n  margin-bottom : 0;\n  opacity       : 0;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 89:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/quicklink/dist/quicklink.mjs
var quicklink = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(3785);
var lazysizes_default = /*#__PURE__*/__webpack_require__.n(lazysizes);
// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/unveilhooks/ls.unveilhooks.js
var ls_unveilhooks = __webpack_require__(6476);
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
;// CONCATENATED MODULE: ./src/scripts/utils/lazyloading.js



 // Quicklink

(0,quicklink/* listen */.o)({
  ignores: [/\/logout/, uri => uri.includes('/account'), uri => uri.includes('.zip'), (uri, elem) => elem.hasAttribute('noprefetch')]
}); // Fastclick

const attachFastClick = __webpack_require__(6705);

attachFastClick.attach(document.body); // Lazysizes

(lazysizes_default()).cfg.lazyClass = 'lazyload';
(lazysizes_default()).cfg.customMedia = { ...breakpoints/* px_queries */.YF
}; // Custom
// Fire event called 'elementinview' for elements with 'lazyscript' class

document.addEventListener('DOMContentLoaded', function () {
  let lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'));

  if ('IntersectionObserver' in window) {
    let options = {
      threshold: 0.1
    };
    let lazyElementObserver = new IntersectionObserver(function (entries, options) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyTarget = entry.target;
          let event = new Event('elementinview');
          lazyTarget.dispatchEvent(event);
          lazyElementObserver.unobserve(lazyTarget);
        }
      });
    });
    lazyElements.forEach(function (el) {
      lazyElementObserver.observe(el);
    });
  } else {
    console.warn('IntersectionObserver not found. Dispatching all events..');
    let lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'));
    lazyElements.forEach(el => {
      var event = new Event('elementinview');
      el.dispatchEvent(event);
    });
  }
}, {
  passive: true
});
// EXTERNAL MODULE: ./src/scripts/vue/main.js + 1 modules
var main = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
// EXTERNAL MODULE: ./src/scripts/vue/components/Modal.vue + 3 modules
var Modal = __webpack_require__(6908);
// EXTERNAL MODULE: ./node_modules/local-storage/local-storage.js
var local_storage = __webpack_require__(9982);
var local_storage_default = /*#__PURE__*/__webpack_require__.n(local_storage);
// EXTERNAL MODULE: ./src/scripts/vue/mixins/locations.js
var locations = __webpack_require__(9059);
;// CONCATENATED MODULE: ./src/scripts/sections/region-popup.js




const MODAL_KEY = `${locations/* LOCATION_STORAGE_KEY */.Hp}_modalViewed`;
window.PSTheme.Vue.RegionModal = new (vue_min_default())({
  name: "RegionModal",
  components: {
    Modal: Modal/* default */.Z
  },
  mixins: [locations/* locationsMixin */.B2],

  data() {
    return {
      mounted: false,
      showModal: false,
      displayCountryCode: null,
      displayCountryName: null,
      displayCountryUrl: null
    };
  },

  mounted() {
    this.mounted = true;
  },

  watch: {
    location: function (newLocation, oldLocation) {
      if (!newLocation || !this.isInRegions) {
        return;
      }

      const {
        URL,
        CODE,
        COUNTRY
      } = locations/* UBCO_REGIONS */.gu[newLocation];
      this.displayCountryCode = CODE;
      this.displayCountryName = COUNTRY;
      this.displayCountryUrl = `https://${URL}`; // this.updateUrlIfExists(`${this.displayCountryUrl}${window.location.pathname}`);

      this.showHideModal();
    }
  },
  methods: {
    updateUrlIfExists(url) {
      var vm = this;
      var request = new XMLHttpRequest();
      request.open("GET", url, true);

      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status != 404) {
            vm.countryUrl = url;
          }
        }
      };

      request.send();
    },

    showHideModal() {
      if (this.urlCountryCode !== this.displayCountryCode) {
        this.showModal = !local_storage_default()(MODAL_KEY);
      }
    },

    closeModal() {
      this.showModal = false;
      local_storage_default()(MODAL_KEY, true);
    }

  }
}).$mount(".region__modal");
// EXTERNAL MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue + 5 modules
var TransitionExpand = __webpack_require__(9079);
;// CONCATENATED MODULE: ./src/scripts/sections/header.js




window.PSTheme.Vue.Header = new (vue_min_default())({
  name: 'Header',
  components: {
    TransitionExpand: TransitionExpand/* default */.Z
  },
  mixins: [locations/* locationsMixin */.B2],
  data: {
    cartCount: 0,
    secondMenuIdx: null,
    thirdMenuIdx: null
  },

  mounted() {
    if (this.$refs.cart_count) {
      this.cartCount = this.$refs.cart_count.dataset.count || 0;
    }

    let header = document.querySelector('.site-header');
    var isExplorePage = false;
    var isIndexPage = false;

    if (header && (header.classList.contains('header-template-page.2x2-adventure-bike') || header.classList.contains('header-template-page.2x2-work-bike') || header.classList.contains('header-template-page.explore-power'))) {
      isExplorePage = true;
    }

    if (header && header.classList.contains('header-template-index')) {
      isIndexPage = true;
    }

    if (isIndexPage) {
      this.$actions.removeDarkMode();
      window.addEventListener('scroll', this.handleScroll);
    }

    if (isExplorePage && window.innerWidth > 1023) {
      let main = document.querySelector('main.app__body');
      this.$actions.removeDarkMode();
      main.addEventListener('scroll', this.handleScroll);
    } else if (isExplorePage) {
      this.$actions.removeDarkMode();
      window.addEventListener('scroll', this.handleScroll);
    }

    this.updateCurrencyRedirectLinks();
  },

  methods: {
    openMenu() {
      this.secondMenuIdx = null;
      this.thirdMenuIdx = null;
      this.$actions.openMenu();
    },

    toggleMenu() {
      this.secondMenuIdx = null;
      this.thirdMenuIdx = null;
      this.$actions.toggleMenu();
    },

    toggleSecondMenu(secondMenuKey) {
      if (this.$store.menuActive == false) {
        this.$actions.openMenu();
      }

      if (this.secondMenuIdx !== secondMenuKey) {
        this.secondMenuIdx = secondMenuKey;
      } else {
        this.secondMenuIdx = null;

        if (window.matchMedia(breakpoints/* mq_breakpoints.--tablet-lg-up */.RS["--tablet-lg-up"]).matches) {
          this.toggleMenu();
        }
      }

      this.thirdMenuIdx = null;
    },

    toggleThirdMenu(thirdMenuKey, _) {
      if (this.thirdMenuIdx !== thirdMenuKey) {
        this.thirdMenuIdx = thirdMenuKey;
      } else {
        this.thirdMenuIdx = null;
      }
    },

    toggleSearch() {
      this.$actions.toggleSearch();
    },

    toggleCurrencySelectorGlobal() {
      this.$actions.toggleCurrencySelector();
    },

    toggleMobileCurrencyGlobal() {
      this.$actions.toggleMobileCurrency();
    },

    updateCartCount(amount) {
      this.cartCount = Number(this.cartCount) + amount;
    },

    setCartCount(cart_count) {
      this.cartCount = cart_count;
    },

    handleScroll() {
      let main = document.querySelector('main.app__body');
      let homeSliderEl = document.querySelector('.banner-video-wrap');
      let exploreBannerEl = document.querySelector('.explore-page__hero');
      var scrollPosition = 0; // SCROLL ON HOME PAGE

      if (homeSliderEl) {
        var firstBlockElement = homeSliderEl;
      } // SCROLL ON EXPLORE PAGE


      if (exploreBannerEl) {
        var firstBlockElement = exploreBannerEl;
      } // GET SCROLL FORM WINDOW OR <MAIN>


      if (main.scrollTop > 0 && window.innerWidth > 1023) {
        scrollPosition = main.scrollTop;
      } else {
        scrollPosition = window.scrollY;
      }

      if (firstBlockElement) {
        var homeSlider = firstBlockElement.offsetHeight;

        if (scrollPosition >= homeSlider && this.$store.menuDark == false) {
          this.$actions.toggleMenuColor();
        } else if (scrollPosition <= homeSlider && this.$store.menuDark == true) {
          this.$actions.toggleMenuColor();
        }
      }
    },

    goToTop() {
      let mainScroll = document.querySelector('main.app__body'); // Add scrolling class to block snap scroll snap property

      mainScroll.classList.add('scrolling'); // Remove scrolling after 1 sec

      setTimeout(() => {
        mainScroll.classList.remove('scrolling');
      }, 1000); // Scroll page to top

      document.querySelector('main.app__body').scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },

    updateCurrencyRedirectLinks() {
      // Get current URL
      let current_url = window.location.pathname; // Get currency selector list

      let currencyList = this.$refs.currencySelectorList.querySelectorAll('li');
      let mobileCurrencyList = this.$refs.mobileCurrencySelectorList.children; // Update desktop links

      currencyList.forEach(currencyItem => {
        // Get current url and append the current page
        let newUrl = currencyItem.firstChild.href + current_url.substring(1); // Update currency link on DOM

        currencyItem.firstChild.href = newUrl;
      }); // Update mobile links

      Object.values(mobileCurrencyList).forEach(currencyItem => {
        // Get current url and append the current page
        let newUrl = currencyItem.firstChild.href + current_url.substring(1); // Update currency link on DOM

        currencyItem.firstChild.href = newUrl;
      });
    }

  }
}).$mount('.app__header');
// EXTERNAL MODULE: ./node_modules/@splidejs/vue-splide/src/js/index.js + 9 modules
var js = __webpack_require__(5493);
// EXTERNAL MODULE: ./node_modules/@splidejs/splide/dist/css/themes/splide-default.min.css
var splide_default_min = __webpack_require__(881);
;// CONCATENATED MODULE: ./src/scripts/utils/throttle.js
const Throttle = (fn, wait) => {
  var time = Date.now();
  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductFormCard.vue?vue&type=template&id=7844e19f&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-fifteen__card-content"},[_vm._t("default"),_vm._v(" "),(_vm.activeVariant)?_c('price',{attrs:{"price":_vm.price,"sale-price":_vm.compareAtPrice,"price-varies":false,"show-sale-price-first":true,"show-gst-msg":false,"show-currency":true}}):_vm._e(),_vm._v(" "),_c('form',{ref:"form",staticClass:"product-card-form",attrs:{"id":_vm.id,"method":"post","action":"/cart/add","accept-charset":"UTF-8","enctype":"multipart/form-data"}},[(!_vm.hasOnlyDefaultVariant)?_vm._l((_vm.optionsWithValues),function(option,index){return _c('div',{key:("option-[" + (option.name) + "]")},[_c('label',{attrs:{"for":("option-" + index)}},[_vm._v("\n          Select your "+_vm._s(option.name)+":\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOptions[index]),expression:"selectedOptions[index]"}],attrs:{"id":("option-" + index)},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.selectedOptions, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onOptionChange($event)}]}},_vm._l((option.values),function(value){return _c('option',{key:("option-[" + (option.name) + "]-value[" + value + "]"),domProps:{"selected":_vm.selectedOptions[index] === value ? 'selected' : null,"value":value}},[_vm._v("\n            "+_vm._s(value)+"\n          ")])}),0)])}):_vm._e(),_vm._v(" "),(_vm.activeVariantId)?_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.activeVariantId}}):_vm._e(),_vm._v(" "),_c('input',{attrs:{"name":"quantity","type":"hidden"},domProps:{"value":_vm.quantity}}),_vm._v(" "),_c('button',{staticClass:"btn btn--full orange-fill",attrs:{"disabled":_vm.disabled || _vm.added},domProps:{"textContent":_vm._s(_vm.addToCartText)},on:{"click":function($event){$event.preventDefault();return _vm.addProduct(_vm.activeVariantId)}}})],2)],2)}
var staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/Price.vue + 3 modules
var Price = __webpack_require__(9911);
// EXTERNAL MODULE: ./src/scripts/utils/cart.js
var cart = __webpack_require__(7342);
;// CONCATENATED MODULE: ./src/scripts/vue/mixins/productForm.js


const productFormMixin = {
  mixins: [locations/* locationsMixin */.B2],

  data() {
    return {
      currentShippingLabel: "",
      DepositPaymentQuestion: null,
      InStockLabel: null,
      isAdded: false,
      isAdding: false,
      minQuantity: 1,
      OnDepositEtaLabel: null,
      quantity: 1,
      selectedOptions: [],
      ShippingQuestionDeposit: null,
      ShippingQuestionInStock: null,
      variants: []
    };
  },

  mounted() {
    this.init();
  },

  props: {
    id: {
      type: Number,
      default: null
    },
    product: {
      type: Object,
      default: null
    },
    metafields: {
      type: Object,
      default: null
    },
    variantsInventoryQuantity: {
      type: Array,
      default: []
    },
    hasDefaultVariant: {
      type: Boolean,
      default: false
    },
    activeVariantId: {
      type: Number,
      default: null
    },
    optionsWithValues: {
      type: Object,
      default: null
    },
    hasOnlyDefaultVariant: {
      type: Boolean,
      default: true
    },
    isTaxIncluded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    lineitemPropertiesRegular() {
      return {
        "Estimated shipping": this.shippingEtaValue,
        _shipping_eta_label: this.shippingEtaLabel,
        _shipping_estimate_url: this.shippingEstimateUrl
      };
    },

    lineitemPropertiesDeposit() {
      return { ...this.lineitemPropertiesRegular,
        _variant_id: this.activeVariantId,
        _product_id: this.product.id,
        _handle: this.product.handle,
        _product_title: this.product.title,
        _variant_title: this.activeVariant.title,
        _price: this.activeVariant.price,
        _image: this.product.images[0] || null,
        _product_type: this.product.type,
        _payment_info: this.paymentInfo,
        _payment_url: this.DepositPaymentQuestion
      };
    },

    paymentInfo() {
      if (this.metafields && this.metafields.hasOwnProperty("payment")) {
        var paymentInformation = this.metafields.payment;

        if (this.metafields.payment.includes("**")) {
          paymentInformation = "";
          let parts = this.metafields.payment.split("**");

          for (let i = 0; i < parts.length; i++) {
            if (i % 2 == 1) {
              paymentInformation += '<span class="orange">';
            }

            paymentInformation += parts[i];

            if (i % 2 == 1) {
              paymentInformation += "</span>";
            }
          }
        }

        return paymentInformation;
      }
    },

    shippingEstimate() {
      if (this.metafields && this.metafields.hasOwnProperty("shipping_eta")) {
        return this.metafields.shipping_eta;
      }
    },

    shippingEstimateInStock() {
      if (this.metafields && this.metafields.hasOwnProperty("shipping_eta_in_stock")) {
        return this.metafields.shipping_eta_in_stock;
      }

      return null;
    },

    saleExpiryDate() {
      if (this.metafields && this.metafields.hasOwnProperty("sale_expiry_date")) {
        return this.metafields.sale_expiry_date;
      }

      return null;
    },

    outOfStock() {
      if (this.metafields && this.metafields.hasOwnProperty("out_of_stock")) {
        return this.metafields.out_of_stock ? 1 : 0;
      }

      return null;
    },

    shippingEstimateLabel() {
      if (this.metafields && this.metafields.hasOwnProperty("shipping_eta_label")) {
        return this.metafields.shipping_eta_label;
      }

      return null;
    },

    setQuantity() {
      if (this.metafields && this.metafields.hasOwnProperty("set_quantity")) {
        return this.metafields.set_quantity;
      }

      return null;
    },

    maxQuantity() {
      const {
        variantsInventoryQuantity,
        activeVariantId
      } = this;

      if (variantsInventoryQuantity && activeVariantId) {
        return variantsInventoryQuantity[activeVariantId];
      }

      return 1;
    },

    price() {
      const {
        activeVariant = null
      } = this;
      const price = activeVariant.price;

      if (activeVariant === null) {
        return null;
      }

      return price;
    },

    compareAtPrice() {
      const {
        activeVariant = null
      } = this;
      const {
        compare_at_price,
        price
      } = activeVariant;

      if (activeVariant === null) {
        return null;
      }

      if (activeVariant !== null && (compare_at_price === 0 || price >= compare_at_price)) {
        return 0;
      }

      return activeVariant.compare_at_price;
    },

    submitDisabled() {
      return !this.product.available || !this.activeVariant || !this.activeVariant.available;
    },

    isSoldOut() {
      return this.activeVariant && !this.activeVariant.available;
    },

    activeVariant() {
      return this.getActiveVariant();
    },

    addToCartText() {
      const {
        region_unavailable,
        sold_out,
        add_to_cart_success,
        add_to_cart
      } = this.$language.product; // commented as we no longer have region unavailable
      // if (this.isAU) return region_unavailable;

      if (this.isSoldOut) return sold_out;
      if (this.isAdded) return add_to_cart_success;
      return add_to_cart;
    },

    shippingEstimateUrl() {
      if (this.ShippingQuestionInStock || this.ShippingQuestionDeposit || this.variantsInventoryQuantity) {
        if (this.maxQuantity > 0) {
          return this.ShippingQuestionInStock;
        } else {
          return this.ShippingQuestionDeposit;
        }
      }

      return null;
    },

    shippingEtaLabel() {
      if (this.maxQuantity > 0) {
        return this.InStockLabel;
      } else {
        return `${this.OnDepositEtaLabel}<br/>`;
      }
    },

    shippingEtaValue() {
      if (this.maxQuantity > 0) {
        return this.shippingEstimateInStock;
      } else {
        return this.shippingEstimate;
      }
    }

  },
  methods: {
    init() {
      this.successText = this.$language.product.add_to_cart_success;
      const {
        ShippingQuestionInStock,
        ShippingQuestionDeposit,
        DepositPaymentQuestion,
        InStockLabel,
        OnDepositEtaLabel
      } = window.PSTheme.Settings.Product;
      this.ShippingQuestionInStock = ShippingQuestionInStock;
      this.ShippingQuestionDeposit = ShippingQuestionDeposit;
      this.DepositPaymentQuestion = DepositPaymentQuestion;
      this.InStockLabel = InStockLabel;
      this.OnDepositEtaLabel = OnDepositEtaLabel;

      if (this.product) {
        const {
          variants
        } = this.product;
        this.variants = variants;
      }

      if (this.activeVariant) {
        this.selectedOptions = [...this.activeVariant.options];
      }
    },

    regularAddItem(variantID) {
      return (0,cart/* addItem */.jX)(variantID, {
        quantity: this.quantity,
        properties: this.lineitemPropertiesRegular
      }).then(() => {
        this.isAdded = true;
        window.PSTheme.Vue.Header.updateCartCount(this.quantity);
        return this.isAdded;
      });
    },

    addDepositItem(depositVariantID) {
      return (0,cart/* addItem */.jX)(depositVariantID, {
        quantity: this.quantity,
        properties: this.lineitemPropertiesDeposit
      }).then(() => {
        this.isAdded = true;
        window.PSTheme.Vue.Header.updateCartCount(this.quantity);
        return this.isAdded;
      });
    },

    addToCart(variantID) {
      return (0,cart/* getState */.y0)().then(({
        items
      }) => {
        let quantityToAdd = 1;
        const depositVariantID = window.PSTheme.Settings.DepositProduct || null;
        items.forEach(({
          variant_id,
          quantity
        }) => {
          if (variant_id === variantID) {
            quantityToAdd += quantity;
          }
        });

        if (quantityToAdd > this.maxQuantity && depositVariantID && this.product.type == "Bikes") {
          return this.addDepositItem(depositVariantID, variantID);
        } else {
          return this.regularAddItem(variantID);
        }
      });
    },

    findVariantById(variantId = null) {
      const {
        variants
      } = this;

      if (!variants || !variantId) {
        return;
      }

      return variants.find(({
        id
      }) => id === variantId);
    },

    getActiveVariant() {
      const {
        variants,
        activeVariantId
      } = this;

      if (!variants || !variants.length || !activeVariantId) {
        return;
      }

      return this.findVariantById(activeVariantId);
    },

    updateActiveVariant({
      id = null
    }) {
      if (id === null) {
        return;
      }

      this.activeVariantId = id;
    },

    findVariantBySelected() {
      return this.variants.find(variant => {
        return this.selectedOptions.every((option, index) => {
          return option === variant.options[index];
        });
      }, this);
    },

    onOptionChange($event) {
      this.updateActiveVariant(this.findVariantBySelected());
    }

  }
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductFormCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProductFormCardvue_type_script_lang_js_ = ({
  name: "ProductFormCard",
  components: {
    Price: Price/* default */.Z
  },
  mixins: [productFormMixin],
  methods: {
    addProduct(activeVariantId) {
      this.addToCart(activeVariantId);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductFormCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductFormCardvue_type_script_lang_js_ = (ProductFormCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductFormCard.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_ProductFormCardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductFormCard = (component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/PopupModal.vue?vue&type=template&id=31f15dfb&
var PopupModalvue_type_template_id_31f15dfb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display || (_vm.Shopify && _vm.Shopify.designMode))?_c('div',{class:[
    'popup-modal',
    ("popup-modal--" + (_vm.Shopify.designMode ? 'static' : _vm.position)),
    {'isOpen': _vm.visible }],on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.close()},"close":function($event){return _vm.close()}}},[_vm._t("default")],2):_vm._e()}
var PopupModalvue_type_template_id_31f15dfb_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/scripts/vue/mixins/userSession.js
var userSession = __webpack_require__(9767);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/PopupModal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//


const SESSION_KEY = 'PS_POPUP_MODAL';
const abortController = new AbortController();
/* harmony default export */ var PopupModalvue_type_script_lang_js_ = ({
  name: "PopupModal",
  mixins: [userSession/* userSessionMixin */.O8],

  data() {
    return {
      mounted: false,
      display: false,
      visible: false,
      displayed: false,
      Shopify: null,
      scrollSection: null
    };
  },

  props: {
    position: {
      type: String,
      default: 'center'
    },
    trigger: {
      type: Object,
      default: function () {
        return {
          type: null,
          // 'time_delay', 'scroll_depth', 'time_delay_after_click' 'visit_duration', 'after_section_number'
          value: null // number

        };
      }
    },
    nextAppears: {
      type: String,
      default: 'session' // session, cache

    }
  },
  watch: {
    display: function (val) {
      if (val) {
        setTimeout(() => {
          this.visible = true;
        }, 100);
      }
    },
    visible: function (val) {
      if (!val) {
        setTimeout(() => {
          this.display = false;
        }, 1000);
      }
    },
    firstClick: function (val) {
      if (val !== null && this.trigger.type === 'time_delay_after_click') {
        this.displayVisitDuration(this.trigger.value, this.firstClick);
      }
    }
  },
  methods: {
    // commented because the section is now global, we do not need an id that is unique to this section
    // getSessionKey() {
    //   return `${SESSION_KEY}_${this.$attrs.id}`;
    // },
    strIsTrue(string) {
      return string === 'true';
    },

    checkIfDisplayed() {
      // commented because the section is now global, we do not need an id that is unique to this section
      // const sessionID = this.getSessionKey();
      const sessionID = SESSION_KEY;

      if (this.nextAppears === 'session') {
        this.displayed = this.strIsTrue(js_cookie/* default.get */.Z.get(sessionID));
        return;
      }

      if (this.nextAppears === 'cache') {
        this.displayed = this.strIsTrue(localStorage.getItem(sessionID));
        return;
      }

      this.displayed = false;
    },

    setNextAppears() {
      // commented because the section is now global, we do not need an id that is unique to this section
      // const sessionKey = this.getSessionKey();
      const key = SESSION_KEY;

      switch (this.nextAppears) {
        case 'session':
          js_cookie/* default.set */.Z.set(key, true);
          break;

        case 'cache':
          localStorage.setItem(key, true);
          break;

        default:
          break;
      }

      this.displayed = true;
    },

    open: function (event) {
      if (this.displayed) {
        return;
      }

      this.display = true;
      this.setNextAppears();
    },
    close: function (event) {
      this.visible = false;
    },

    displayDelayTimeout(time = 0) {
      window.setTimeout(() => {
        this.open();
      }, time);
    },

    getSectionDepth(element) {
      if (element) {
        return Math.round(element.getBoundingClientRect().top + window.scrollY);
      }

      return 0;
    },

    isOutOfViewPort(element) {
      // Get elementent's bounding
      const bounding = element.getBoundingClientRect(); // Check if it's out of the viewport on each side

      const out = {};
      out.top = bounding.top < 0;
      out.left = bounding.left < 0;
      out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
      out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
      out.any = out.top || out.left || out.bottom || out.right;
      return out;
    },

    onScrollDepth() {
      const {
        type,
        value
      } = this.trigger;
      let depth = value;
      let canDisplay = window.scrollY >= depth;
      let isOut = null;

      if (type === 'after_section_number') {
        const section = this.getSectionByIndex(value);
        depth = this.getSectionDepth(section);
        isOut = this.isOutOfViewPort(section);
        canDisplay = canDisplay && !isOut.bottom;
      }

      if (canDisplay) {
        this.open();
        abortController.abort();
      }
    },

    displayScrollDepth() {
      document.addEventListener('scroll', this.onScrollDepth.bind(this), {
        passive: true,
        signal: abortController.signal
      });
    },

    getSectionByIndex(number) {
      const main = document.querySelector('main');
      const sections = main.querySelectorAll(`.shopify-section:not(.section-email-popup):not(.app__footer)`);
      const index = sections.length >= number ? number - 1 : sections.length - 1;
      return sections[index];
    },

    displayAfterSectionNumber() {
      this.displayScrollDepth();
    },

    displayVisitDuration(duration = null, start = null) {
      if (!start || !duration) {
        return;
      }

      const dateNow = new Date(Date.now());
      const sessionStarted = new Date(start);
      const elaspsed = dateNow.getTime() - sessionStarted.getTime();
      const remaining = duration - elaspsed;

      if (remaining > 0) {
        this.displayDelayTimeout(remaining);
      } else {
        this.open();
      }
    },

    displayAfterFirstClick(time) {
      if (this.firstClick) {
        this.displayVisitDuration(time, this.firstClick);
      }
    },

    initPopup() {
      const {
        type,
        value
      } = this.trigger;

      switch (type) {
        case 'time_delay':
          this.displayDelayTimeout(value);
          break;

        case 'time_delay_after_click':
          this.displayAfterFirstClick(value);
          break;

        case 'after_section_number':
        case 'scroll_depth':
          this.displayScrollDepth();
          break;

        case 'visit_duration':
          this.displayVisitDuration(value, this.userSession);
          break;

        default:
          this.open();
          break;
      }
    }

  },

  mounted() {
    this.mounted = true;
    this.Shopify = Shopify;
    this.checkIfDisplayed();

    if (this.displayed || Shopify.designMode) {
      return;
    }

    this.initPopup();
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/PopupModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PopupModalvue_type_script_lang_js_ = (PopupModalvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/PopupModal.vue



;


/* normalize component */

var PopupModal_component = (0,componentNormalizer/* default */.Z)(
  components_PopupModalvue_type_script_lang_js_,
  PopupModalvue_type_template_id_31f15dfb_render,
  PopupModalvue_type_template_id_31f15dfb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PopupModal = (PopupModal_component.exports);
;// CONCATENATED MODULE: ./src/scripts/global/modules.js









const anchorNav = document.querySelector(".anchor-nav");

const RedirectOldPages = () => {
  const from = ["/pages/2x2-adventure-bike", "/pages/2x2-work-bike"];
  const to = "/pages/2x2-electric-bike";
  const oldPage = from.some(el => window.location.href.includes(el));
  oldPage ? window.location.href = to : null;
};

RedirectOldPages();

const updateAnchorLinks = (sectionsInViewPort, anchorLinks) => {
  anchorLinks.forEach(link => {
    let start = Number(link.getAttribute("data-section-start"));
    let finish = Number(link.getAttribute("data-section-end"));
    sectionsInViewPort.map(i => {
      i >= start && i <= finish ? link.classList.add("active") : link.classList.remove("active");
    });
  });
};

const AnchorNav = () => {
  if (!anchorNav) {
    return;
  }

  let anchorLinks = anchorNav.querySelectorAll(".anchor-link");
  let body = document.body;
  let anchorNavHeight = anchorNav.offsetHeight;
  body.classList.add("has-anchor-nav");
  body.setAttribute("style", `--anchor-nav-height: ${anchorNavHeight}px;`);
  let shopifySections = document.querySelectorAll("main .shopify-section:not(#shopify-section-footer)");
  shopifySections.forEach((section, i) => {
    const hiddenAnchor = document.createElement("div");
    hiddenAnchor.classList.add("hidden-anchor-link");
    hiddenAnchor.id = i;
    section.appendChild(hiddenAnchor);
  });
  let scrollpos = window.scrollY;
  var bodyRect = document.body.getBoundingClientRect(),
      elemRect = anchorNav.getBoundingClientRect(),
      offset = elemRect.top - bodyRect.top;

  const add_class_on_scroll = () => anchorNav.classList.add("sticky");

  const remove_class_on_scroll = () => anchorNav.classList.remove("sticky");

  const checkScroll = () => {
    scrollpos = window.scrollY;

    if (scrollpos > offset) {
      add_class_on_scroll();
    } else {
      remove_class_on_scroll();
    }
  };

  var isInViewport = function () {
    let sectionsInViewPort = [];
    shopifySections.forEach(element => {
      var position = element.getBoundingClientRect(); // checking for partial visibility

      let sectionId = Number(element.querySelector(".hidden-anchor-link").id);

      if (position.top < window.innerHeight && position.bottom >= 0) {
        sectionsInViewPort.push(sectionId);
      }
    });
    updateAnchorLinks(sectionsInViewPort, anchorLinks);
  };

  anchorLinks.forEach(anchorLink => {
    anchorLink.addEventListener("click", () => {
      anchorNav.classList.remove("active");
    });
  });
  window.addEventListener("scroll", Throttle(checkScroll, 100));
  window.addEventListener("scroll", Throttle(isInViewport, 50));
};

AnchorNav();

function mountModule({
  el = null,
  settings = null,
  idPrefix = ''
}) {
  if (!el || !settings) {
    return;
  }

  const ID = el.parentNode.id;
  settings = { ...settings,
    ...{
      mixins: [locations/* locationsMixin */.B2]
    }
  };
  window.PSTheme.Vue[`${idPrefix}${ID}`] = new (vue_min_default())(settings).$mount(el);
}

function mountModules({
  querySelector = null,
  settings = null,
  idPrefix = ''
}) {
  if (!querySelector || !settings) {
    return;
  }

  const NODE_LIST = Array.from(document.querySelectorAll(querySelector));

  if (!NODE_LIST.length) {
    return;
  }

  NODE_LIST.forEach(el => mountModule({
    el,
    settings,
    idPrefix
  }));
} // Featured-product-block


document.querySelectorAll(".featured-product-block").forEach(featuredProduct => {
  let ID = featuredProduct.parentNode.id;
  window.PSTheme.Vue[`featuredProduct${ID}`] = new (vue_min_default())({
    name: "featuredProduct",
    mixins: [locations/* locationsMixin */.B2],

    data() {
      return {
        showLiveImage: false
      };
    }

  }).$mount(featuredProduct);
}); // ========================================== *
//   MODULES
// ========================================== *
// --- MODULE ONE

mountModules({
  querySelector: ".module-one",
  settings: {
    name: "homeBannerVideo",
    mixins: [locations/* locationsMixin */.B2],

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-one-'
}); // --- MODULE TWO

const moduleTwo = Array.from(document.querySelectorAll(".module-two"));

if (moduleTwo) {
  moduleTwo.forEach(m => {
    let sectionId = m.parentNode.id;
    window.PSTheme.Vue[`module-two-${sectionId}`] = new (vue_min_default())({
      name: "moduleTwo",

      data() {
        return {
          mounted: false
        };
      },

      mounted() {
        this.mounted = true;
      }

    }).$mount(m);
  });
} // --- MODULE THREE


mountModules({
  querySelector: ".module-three",
  settings: {
    name: "moduleThree",

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-three-'
}); // --- MODULE FOUR

const moduleFour = Array.from(document.querySelectorAll(".module-four"));

if (moduleFour) {
  moduleFour.forEach(m => {
    let sectionId = m.parentNode.id;
    window.PSTheme.Vue[`module-four-${sectionId}`] = new (vue_min_default())({
      name: "homeCarousel",
      mixins: [locations/* locationsMixin */.B2],
      components: {
        slider: js/* Splide */.tv,
        slide: js/* SplideSlide */.jw
      },

      data() {
        return {
          mounted: false,
          carouselOptions: {
            perPage: 2,
            arrows: true,
            pagination: false,
            gap: "20px",
            padding: {
              right: "7rem"
            },
            breakpoints: {
              [breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"]]: {
                perPage: 2,
                pagination: true,
                arrows: false,
                gap: "4px",
                padding: {
                  right: "5rem"
                }
              },
              [breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"]]: {
                perPage: 1,
                arrows: false,
                pagination: true,
                gap: "4px",
                padding: {
                  right: "5rem"
                }
              }
            }
          }
        };
      },

      mounted() {
        this.mounted = true;
      }

    }).$mount(m);
  });
} // --- MODULE FIVE


const moduleFive = Array.from(document.querySelectorAll(".module-five"));

if (moduleFive) {
  moduleFive.forEach(m => {
    let sectionId = m.parentNode.id;
    window.PSTheme.Vue[`module-five-${sectionId}`] = new (vue_min_default())({
      name: "moduleFive",
      components: {
        slider: js/* Splide */.tv,
        slide: js/* SplideSlide */.jw
      },
      mixins: [locations/* locationsMixin */.B2],

      data() {
        return {
          mounted: false,
          carouselOptions: {
            perPage: 1,
            arrows: true,
            pagination: true
          }
        };
      },

      mounted() {
        this.mounted = true;
      }

    }).$mount(m);
  });
} // --- MODULE SIX


mountModules({
  querySelector: ".module-six",
  settings: {
    name: "moduleSix",

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-six-'
}); // --- MODULE SEVEN

const moduleSeven = Array.from(document.querySelectorAll(".module-seven"));

if (moduleSeven) {
  moduleSeven.forEach(m => {
    let sectionId = m.parentNode.id;
    window.PSTheme.Vue[`module-seven-${sectionId}`] = new (vue_min_default())({
      name: "moduleSeven",

      data() {
        return {
          mounted: false
        };
      },

      mounted() {
        this.mounted = true;
      }

    }).$mount(m);
  });
} // --- MODULE NINE


const moduleNine = Array.from(document.querySelectorAll(".module-nine"));

if (moduleNine) {
  moduleNine.forEach(m => {
    let sectionId = m.parentNode.id;
    window.PSTheme.Vue[`module-nine-${sectionId}`] = new (vue_min_default())({
      name: "blogCarousel",
      components: {
        slider: js/* Splide */.tv,
        slide: js/* SplideSlide */.jw
      },

      data() {
        return {
          mounted: false,
          carouselOptions: {
            type: "loop",
            perPage: 3,
            arrows: true,
            pagination: false,
            gap: "20px",
            padding: {
              right: "0"
            },
            breakpoints: {
              [breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"]]: {
                perPage: 2,
                pagination: true,
                arrows: false,
                gap: "20px",
                padding: {
                  right: "0"
                }
              },
              [breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"]]: {
                perPage: 1,
                arrows: false,
                pagination: true,
                gap: "4px",
                padding: {
                  right: "5rem"
                }
              }
            }
          }
        };
      },

      mounted() {
        this.mounted = true;
      }

    }).$mount(m);
  });
} // --- MODULE TEN


const moduleTen = Array.from(document.querySelectorAll(".module-ten"));

if (moduleTen) {
  moduleTen.forEach(m => {
    let sectionId = m.parentNode.id;
    window.PSTheme.Vue[`module-ten-${sectionId}`] = new (vue_min_default())({
      name: "moduleTen",
      components: {
        slider: js/* Splide */.tv,
        slide: js/* SplideSlide */.jw
      },

      data() {
        return {
          mounted: false,
          carouselOptions: {
            perPage: 1,
            arrows: false,
            pagination: false,
            gap: 0,
            mediaQuery: 'max',
            destroy: true,
            breakpoints: {
              650: {
                perPage: 1,
                arrows: false,
                pagination: true,
                gap: 0,
                destory: false
              }
            }
          }
        };
      },

      methods: {
        toggleClick(event) {
          const {
            target
          } = event;
          const {
            clickToggle
          } = target.dataset;
          const activeClass = 'active';
          const hiddenClass = 'visually-hidden';
          const dataId = `[data-id=${clickToggle}]`;
          const allTargets = document.querySelectorAll(dataId);
          target.querySelector('.module-ten__toggle').classList.toggle(activeClass); // const mq = window.matchMedia('(min-width: 40em)');

          console.log({
            allTargets
          });
          Array.from(allTargets).forEach(target => target.classList.toggle(hiddenClass));
        }

      },

      mounted() {
        this.mounted = true;
      }

    }).$mount(m);
  });
} // --- MODULE Fifteen


mountModules({
  querySelector: ".module-eleven",
  settings: {
    name: "moduleEleven",
    components: {
      ProductFormCard: ProductFormCard
    },

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-eleven-'
}); // --- MODULE Twelve

mountModules({
  querySelector: ".module-twelve",
  settings: {
    name: "moduleTwelve",

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-twelve-'
}); // --- MODULE Thirteen

mountModules({
  querySelector: ".module-thirteen",
  settings: {
    name: "moduleThirteen",

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-thirteen-'
}); // --- MODULE Fifteen

mountModules({
  querySelector: ".module-fifteen",
  settings: {
    name: "moduleFifteen",
    components: {
      ProductFormCard: ProductFormCard
    },

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-fifteen-'
}); // --- MODULE Sixteen

mountModules({
  querySelector: ".module-sixteen",
  settings: {
    name: "moduleSixteen",

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-sixteen-'
}); // --- MODULE Seventeen

mountModules({
  querySelector: ".module-seventeen",
  settings: {
    name: "moduleSeventeen",

    data() {
      return {
        mounted: false
      };
    },

    mounted() {
      this.mounted = true;
    }

  },
  idPrefix: 'module-seventeen-'
}); // --- Email popup

mountModules({
  querySelector: ".section-email-popup",
  settings: {
    name: "EmailPopupForm",

    data() {
      return {
        formPosted: false,
        formId: null
      };
    },

    components: {
      PopupModal: PopupModal
    },
    methods: {
      close: function () {
        this.$refs.popup.close();
      }
    },

    beforeMount() {
      const urlParams = new URLSearchParams(window.location.search);
      this.formPosted = !!urlParams.get('contact_posted');
      this.formId = window.location.hash.replace('#', '');
    },

    mounted() {
      this.mounted = true;

      if (this.formPosted) {
        const popup = this.$refs.popup;
        const {
          type,
          value
        } = popup.trigger;

        if (type === 'after_section_number') {
          const section = popup.getSectionByIndex(value);
          const depth = popup.getSectionDepth(section);
          window.scrollTo(0, depth);
        }

        popup.open();
        window.setTimeout(() => {
          popup.close();
        }, 5000);
      }
    }

  },
  idPrefix: 'email-popup-'
});
;// CONCATENATED MODULE: ./src/scripts/sections/footer.js



window.PSTheme.Vue.Footer = new (vue_min_default())({
  name: 'Footer',
  mixins: [locations/* locationsMixin */.B2],
  components: {
    TransitionExpand: TransitionExpand/* default */.Z
  },
  data: {
    showFirstMenu: false,
    showSecondMenu: false
  },
  methods: {
    toggleNav(value) {
      if (value == "first") {
        this.showFirstMenu = !this.showFirstMenu;
      } else if (value == "second") {
        this.showSecondMenu = !this.showSecondMenu;
      }
    }

  }
}).$mount('.app__footer');
;// CONCATENATED MODULE: ./src/scripts/layout/theme.js
/**
 * Theme Layout Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts and styles for all pages.
 *
 * @namespace theme
 * @file vendors@layout.theme.js
 * @file layout.theme.js
 *
 */

/* styles */
 //TODO: Optimize to be included only on checkout theme


/* utils */

 // import 'scripts/utils/replace_no_image'

/* vue */


/* global */






/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "YF": function() { return /* binding */ px_queries; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 7342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ addItems; },
/* harmony export */   "$G": function() { return /* binding */ updateItem; },
/* harmony export */   "H5": function() { return /* binding */ clearItems; },
/* harmony export */   "Qk": function() { return /* binding */ updateNote; },
/* harmony export */   "jX": function() { return /* binding */ addItem; },
/* harmony export */   "y0": function() { return /* binding */ getState; }
/* harmony export */ });
/* unused harmony exports getItemIndex, getItem, addItemFromForm, updateItemQuantityById, removeItem, getAttributes, updateAttributes, clearAttributes, getNote, clearNote, getShippingRates, cartChange */
/**
 * Cart API helper methods
 * ------------------------------------------------------------------------------
 * Reusable code for cart API methods
 *
 */

/**
 * Returns the state object of the cart
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */
function getState() {
  return cart();
}
/**
 * Returns the index of the cart line item
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the index number of the line item
 */

function getItemIndex(key) {
  validate_key(key);
  return cart().then(function (state) {
    var index = -1;
    state.items.forEach(function (item, i) {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return index;
  });
}
/**
 * Fetches the line item object
 * @param {string} key The unique key of the line item
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function getItem(key) {
  validate_key(key);
  return cart().then(function (state) {
    var lineItem = null;
    state.items.forEach(function (item) {
      lineItem = item.key === key ? item : lineItem;
    });

    if (lineItem === null) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return lineItem;
  });
}
/**
 * Add a new line item to the cart
 * @param {number} id The variant's unique ID
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function addItem(id, options) {
  options = options || {};
  validate_id(id);
  return cartAdd(id, options.quantity, options.properties);
}
/**
 * Add a new line item to the cart from a product form
 * @param {object} form DOM element which is equal to the <form> node
 * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
 */

function addItemFromForm(form) {
  validate_form(form);
  var formData = new FormData(form);
  validate_id(parseInt(formData.get('id'), 10));
  return cartAddFromForm(formData);
}
/**
 * Changes the quantity and/or properties of an existing line item.
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @param {object} options Optional values to pass to /cart/add.js
 * @param {number} options.quantity The quantity of items to be added to the cart
 * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function updateItem(key, options) {
  validate_key(key);
  validate_options(options);
  return getItemIndex(key).then(function (line) {
    return cartChange(line, options);
  });
}
/**
 * 
 * Changes the quantity of an existing line item through it's variant id, useful when the key is not accessable.
 * @param {integer} variant.id
 * @param {number} quantity Setting to 0 will remove the item
 */

function updateItemQuantityById(id, qty) {
  return cartUpdateQuantityById(id, qty);
}
/**
 * Removes a line item from the cart
 * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function removeItem(key) {
  validate_key(key);
  return getItemIndex(key).then(function (line) {
    return cartChange(line, {
      quantity: 0
    });
  });
}
/**
 * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
 * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
 */

function clearItems() {
  return cartClear();
}
/**
 * Gets all cart attributes
 * @returns {Promise} Resolves with the cart attributes object
 */

function getAttributes() {
  return cart().then(function (state) {
    return state.attributes;
  });
}
/**
 * Sets all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */

function updateAttributes(attributes) {
  return cartUpdate({
    attributes: attributes
  });
}
/**
 * Clears all cart attributes
 * @returns {Promise} Resolves with the cart state object
 */

function clearAttributes() {
  return getAttributes().then(function (attributes) {
    for (var key in attributes) {
      attributes[key] = '';
    }

    return updateAttributes(attributes);
  });
}
/**
 * Gets cart note
 * @returns {Promise} Resolves with the cart note string
 */

function getNote() {
  return cart().then(function (state) {
    return state.note;
  });
}
/**
 * Sets cart note
 * @returns {Promise} Resolves with the cart state object
 */

function updateNote(note) {
  return cartUpdate({
    note: note
  });
}
/**
 * Clears cart note
 * @returns {Promise} Resolves with the cart state object
 */

function clearNote() {
  return cartUpdate({
    note: ''
  });
}
/**
 * Get estimated shipping rates.
 * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
 */

function getShippingRates() {
  return cartShippingRates();
} // add multiple items one times

function addItems(items) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify({
    items
  });
  return fetchJSON('/cart/add.js', config);
}
/**
 * Request helper functions
 */

function getDefaultRequestConfig() {
  return JSON.parse(JSON.stringify({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
}

function fetchJSON(url, config) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }

    return response.json();
  });
}

function cart() {
  return fetchJSON('/cart.js', getDefaultRequestConfig());
}

function cartAdd(id, quantity, properties) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify({
    id: id,
    quantity: quantity,
    properties: properties
  });
  return fetchJSON('/cart/add.js', config);
}

function cartAddFromForm(formData) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];
  config.method = 'POST';
  config.body = formData;
  return fetchJSON('/cart/add.js', config);
}

function cartChange(line, options) {
  var config = getDefaultRequestConfig();
  options = options || {};
  config.method = 'POST';
  config.body = JSON.stringify({
    line: line,
    quantity: options.quantity,
    properties: options.properties
  });
  return fetchJSON('/cart/change.js', config);
}

function cartUpdateQuantityById(id, qty) {
  var config = getDefaultRequestConfig();
  delete config.headers['Content-Type'];
  config.method = 'POST';
  config.body = new URLSearchParams(`quantity=${qty}&id=${id}`);
  return fetchJSON('/cart/change.js', config);
}

function cartClear() {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  return fetchJSON('/cart/clear.js', config);
}

function cartUpdate(body) {
  var config = getDefaultRequestConfig();
  config.method = 'POST';
  config.body = JSON.stringify(body);
  return fetchJSON('/cart/update.js', config);
}

function cartShippingRates() {
  return fetchJSON('/cart/shipping_rates.json', getDefaultRequestConfig());
}
/**
 * Validation helper functions
 */


function validate_key(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
  }
}

function validate_quantity(quantity) {
  if (typeof quantity !== 'number' || isNaN(quantity)) {
    throw new TypeError('Theme Cart: An object which specifies a quantity or properties value is required');
  }
}

function validate_id(id) {
  if (typeof id !== 'number' || isNaN(id)) {
    throw new TypeError('Theme Cart: Variant ID must be a number');
  }
}

function validate_properties(properties) {
  if (typeof properties !== 'object') {
    throw new TypeError('Theme Cart: Properties must be an object');
  }
}

function validate_form(form) {
  if (!(form instanceof HTMLFormElement)) {
    throw new TypeError('Theme Cart: Form must be an instance of HTMLFormElement');
  }
}

function validate_options(options) {
  if (typeof options !== 'object') {
    throw new TypeError('Theme Cart: Options must be an object');
  }

  if (typeof options.quantity === 'undefined' && typeof options.properties === 'undefined') {
    throw new Error('Theme Cart: You muse define a value for quantity or properties');
  }

  if (typeof options.quantity !== 'undefined') {
    validate_quantity(options.quantity);
  }

  if (typeof options.properties !== 'undefined') {
    validate_properties(options.properties);
  }
}

/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  menuDark: true,
  showTestRide: true,
  showGoToTop: false,
  searchActive: false,
  currencyDropdown: false,
  mobileCurrencyDropdown: false,
  hasTransparentHeader: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: "NZ"
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleMenuColor() {
    store.menuDark = !store.menuDark;
    store.showTestRide = !store.showTestRide;
    store.hasTransparentHeader = !store.hasTransparentHeader; // If is explore pages

    if (document.querySelector(".explore-page__hero")) {
      store.showGoToTop = !store.showGoToTop;
    }
  },

  toggleSearch() {
    store.menuActive = false; // RESET MENU

    store.searchActive = !store.searchActive; // TOGGLE SEARCH

    store.currencyDropdown = false;

    if (store.hasTransparentHeader === true) {
      this.toggleMenuColor();
    }
  },

  toggleCurrencySelector() {
    store.searchActive = false;
    store.currencyDropdown = !store.currencyDropdown;

    if (store.hasTransparentHeader === true) {
      this.toggleMenuColor();
    }
  },

  toggleMobileCurrency() {
    store.mobileCurrencyDropdown = !store.mobileCurrencyDropdown;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.currencyDropdown = false; // store.showTestRide = false;

    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  },

  removeDarkMode() {
    store.menuDark = false;
    store.showTestRide = false;
    store.hasTransparentHeader = true;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/vue-appear/src/index.js + 1 modules
var src = __webpack_require__(1839);
// EXTERNAL MODULE: ./src/scripts/vue/mixins/userSession.js
var userSession = __webpack_require__(9767);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js








(0,userSession/* setSession */.KY)();
vue_min_default().use(src/* default */.Z, {
  immediate: false,
  toggle: true,
  children: false,
  offset: 0,
  hook: "onEnter",
  delay: 250,
  class: "fadeInSlide",
  selector: null,
  callback: () => {}
});
vue_min_default().use(__webpack_require__(9655));
/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = window.PSTheme.Language;

(vue_min_default()).prototype.$image = (src, size = "750x") => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = "750x") => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, getFormat(globalThis.PSTheme.Settings.Currency)).replace(".00", "");

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

function getFormat(currency) {
  switch (currency) {
    case 'GBP':
      return '£{{amount}}';

    case 'EUR':
      return '€{{amount}}';

    default:
      return '${{amount}}';
  }
}

/***/ }),

/***/ 9059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B2": function() { return /* binding */ locationsMixin; },
/* harmony export */   "Hp": function() { return /* binding */ LOCATION_STORAGE_KEY; },
/* harmony export */   "gu": function() { return /* binding */ UBCO_REGIONS; }
/* harmony export */ });
/* unused harmony exports EUROPE_COUNTRIES, URLS, COUNTRIES, CODES, getUrlCountryCode */
const LOCATION_STORAGE_KEY = 'PSLocation';
const EUROPE_COUNTRIES = ['BE', 'EL', 'LT', 'PT', 'BG', 'ES', 'LU', 'RO', 'CZ', 'FR', 'HU', 'SI', 'DK', 'HR', 'MT', 'SK', 'DE', 'IT', 'NL', 'FI', 'EE', 'CY', 'AT', 'SE', 'IE', 'LV', 'PL', 'IS', 'NO', 'LI', 'CH'];
const UBCO_REGIONS = {
  US: {
    URL: 'ubco.com',
    STORE_URL: 'ubco-bikes.myshopify.com',
    CODE: 'US',
    COUNTRY: 'United States'
  },
  NZ: {
    URL: 'ubco.co.nz',
    STORE_URL: 'ubco-new-zealand.myshopify.com',
    CODE: 'NZ',
    COUNTRY: 'New Zealand'
  },
  GB: {
    URL: 'ubco.uk',
    STORE_URL: 'ubco-GB.myshopify.com',
    CODE: 'GB',
    COUNTRY: 'United Kingdom'
  },
  AU: {
    URL: 'ubco.com.au',
    STORE_URL: 'ubco-australia.myshopify.com',
    CODE: 'AU',
    COUNTRY: 'Australia'
  },
  EU: {
    URL: 'ubco.eu',
    STORE_URL: 'ubco-europe.myshopify.com',
    CODE: 'EU',
    COUNTRY: 'Europe'
  }
};

const objectMap = (obj, fn) => Object.fromEntries(Object.entries(obj).map(([key, value], index) => [key, fn(value, key, index)]));

const URLS = objectMap(UBCO_REGIONS, ({
  URL
}) => URL);
const COUNTRIES = objectMap(UBCO_REGIONS, ({
  COUNTRY
}) => COUNTRY);
const CODES = objectMap(UBCO_REGIONS, ({
  CODE
}) => CODE);

async function getBrowsingContext() {
  const response = await fetch('/browsing_context_suggestions.json');
  const data = await response.json();
  return data;
}

function setLocation(data) {
  localStorage.setItem(LOCATION_STORAGE_KEY, data);
}

function getLocation() {
  const data = localStorage.getItem(LOCATION_STORAGE_KEY);

  if (!data) {
    return null;
  }

  return data;
}

const getCurrentURL = () => {
  const {
    hostname
  } = window.location;
  const {
    Domain = null
  } = PSTheme && PSTheme.Site ? PSTheme.Site : null;
  return Domain || hostname;
};

function getUrlCountryCode() {
  const currentSite = getCurrentURL();
  const current_code = Object.keys(UBCO_REGIONS).find(key => {
    const {
      URL,
      STORE_URL
    } = UBCO_REGIONS[key];
    return currentSite == URL || currentSite == STORE_URL;
  });
  return current_code;
}
;

const isCountryInEurope = (code = null) => code ? EUROPE_COUNTRIES.some(euCode => euCode === code) : false;

const isCountryInRegions = (code = null) => code ? Object.keys(CODES).some(ubcoCode => ubcoCode === code) : false;

const LOCATION = getBrowsingContext().then(context => {
  const {
    country: {
      handle
    }
  } = context.detected_values;
  const key = isCountryInEurope(handle) ? CODES.EU : handle;
  const countryCode = isCountryInRegions(key) ? key : handle;
  setLocation(countryCode);
  return countryCode;
});

const checkCode = (location, code) => location && location === code;

const locationsMixin = {
  data() {
    return {
      location: null,
      locationChecked: false,
      urlCountryCode: getUrlCountryCode()
    };
  },

  async beforeMount() {
    this.location = await LOCATION.then(result => result);
    this.locationChecked = await LOCATION.then(() => true);
  },

  computed: {
    isAU() {
      return checkCode(this.location, CODES.AU);
    },

    isEU() {
      return checkCode(this.location, CODES.EU);
    },

    isUS() {
      return checkCode(this.location, CODES.US);
    },

    isGB() {
      return checkCode(this.location, CODES.GB);
    },

    isNZ() {
      return checkCode(this.location, CODES.NZ);
    },

    isInRegions() {
      return this.location && isCountryInRegions(this.location);
    },

    currency() {
      return window.PSTheme.Settings.Currency;
    }

  }
};

/***/ }),

/***/ 9767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KY": function() { return /* binding */ setSession; },
/* harmony export */   "O8": function() { return /* binding */ userSessionMixin; }
/* harmony export */ });
/* unused harmony export getSession */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1955);

const USER_SESSION_START = 'PS_USS';
const USER_SESSION_FIRST_CLICK = 'PS_UFC';
function setSession(name = null, value = true) {
  if (name === null || js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(name)) {
    return;
  }

  js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(name, value, {
    secure: true,
    domain: PSTheme.Site.Domain
  });
}
function getSession(name = null) {
  if (name === null) {
    return name;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(name);
}

const isUnderfined = variable => variable === 'undefined' || variable === undefined;

const userSessionMixin = {
  data() {
    return {
      userSession: null,
      firstClick: null
    };
  },

  async beforeMount() {
    // user session started
    const dateNow = Date.now();
    const userSession = getSession(USER_SESSION_START);

    if (isUnderfined(userSession)) {
      setSession(USER_SESSION_START, Number(dateNow));
      this.userSession = Number(dateNow);
    } else {
      this.userSession = Number(userSession);
    } // first click


    const firstClick = getSession(USER_SESSION_FIRST_CLICK);

    if (isUnderfined(firstClick)) {
      document.body.addEventListener('click', function (event) {
        const dateClick = Date.now();
        setSession(USER_SESSION_FIRST_CLICK, dateClick);
        this.firstClick = Number(dateClick);
      }.bind(this), {
        passive: true,
        once: true
      });
    } else this.firstClick = Number(firstClick);
  }

};

/***/ }),

/***/ 6908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Modal.vue?vue&type=template&id=1fd2ca72&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.mounted)?_c('div',{staticClass:"site__modal-wrap"},[_c('div',{staticClass:"modal__container"},[_c('div',{staticClass:"modal__close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.886 14.885"}},[_c('g',{attrs:{"fill":"none","stroke":"#1a1818"}},[_c('path',{attrs:{"d":"M.357 14.532L14.532.355M14.53 14.531L.355.354M.357 14.532L14.532.355"}})])])]),_vm._v(" "),_c('div',{staticClass:"modal__content-slot"},[_vm._t("default")],2)])]):_vm._e()])}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Modal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Modalvue_type_script_lang_js_ = ({
  name: "Modal",
  props: ["size"],

  data() {
    return {
      mounted: false
    };
  },

  mounted() {
    this.mounted = true;
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Modalvue_type_script_lang_js_ = (Modalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Modal.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_Modalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Modal = (component.exports);

/***/ }),

/***/ 9911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Price; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Price.vue?vue&type=template&id=61b0ab16&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
       'price',
       _vm.additionalClasses !== '' ? _vm.additionalClasses : ''
   ]},[(_vm.priceVaries)?_c('span',{staticClass:"price__from"},[_vm._v("FROM")]):_vm._e(),_vm._v(" "),(_vm.salePrice && _vm.showSalePriceFirst)?_c('s',{staticClass:"price__money price__money--sale",domProps:{"textContent":_vm._s(_vm.salePriceString())}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"price__money",domProps:{"textContent":_vm._s(_vm.priceString())}}),_vm._v(" "),(_vm.salePrice && !_vm.showSalePriceFirst)?_c('s',{staticClass:"price__money price__money--sale",domProps:{"textContent":_vm._s(_vm.salePriceString())}}):_vm._e(),_vm._v(" "),(_vm.showGstMsg)?_c('small',{staticClass:"price__tax-info"},[(_vm.isTaxIncluded)?[_vm._v("incl. tax")]:[_vm._v("Excl. Tax")]],2):_vm._e()])}
var staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/mixins/locations.js
var locations = __webpack_require__(9059);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Price.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Pricevue_type_script_lang_js_ = ({
  name: "Price",
  mixins: [locations/* locationsMixin */.B2],
  props: {
    additionalClasses: {
      type: String,
      default: ''
    },
    salePrice: {
      type: Number,
      default: 0
    },
    price: {
      type: Number,
      default: 0
    },
    showCurrency: {
      type: Boolean,
      default: false
    },
    showSalePriceFirst: {
      type: Boolean,
      default: false
    },
    priceVaries: {
      type: Boolean,
      default: false
    },
    showGstMsg: {
      type: Boolean,
      default: false
    },
    isTaxIncluded: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    salePriceString() {
      const {
        $money,
        salePrice
      } = this;
      return $money(salePrice);
    },

    priceString() {
      const {
        $money,
        currency = null,
        showCurrency,
        price
      } = this;
      const formatted = $money(price);

      if (currency === null || showCurrency === false) {
        return formatted;
      }

      return `${formatted} ${currency}`;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Price.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Pricevue_type_script_lang_js_ = (Pricevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Price.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_Pricevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Price = (component.exports);

/***/ }),

/***/ 9079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TransitionExpand; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=template&id=484b71e6&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var TransitionExpandvue_type_script_lang_js_ = ({
  name: 'TransitionExpand',
  props: {
    height: {
      type: String,
      required: false,
      default: 'auto'
    },
    fixedEntryHeight: {
      type: String,
      required: false,
      default: null
    },
    linear_padding: {
      type: String,
      required: false,
      default: ''
    },
    linear_margin: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    enter(element) {
      element.style.height = this.fixedEntryHeight || element.scrollHeight + 'px';
      element.style.opacity = 1;

      if (this.linear_padding !== '') {
        element.style.paddingTop = this.linear_padding;
        element.style.paddingBottom = this.linear_padding;
      }

      if (this.linear_margin !== '') {
        element.style.marginTop = this.linear_margin;
        element.style.marginBottom = this.linear_margin;
      }
    },

    afterEnter(element) {
      element.style.height = this.height;
    },

    leave(element) {
      element.style.height = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.height = 0;
        element.style.opacity = 0;

        if (this.linear_padding !== '') {
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
        }

        if (this.linear_margin !== '') {
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
        }
      }, 50);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
 /* harmony default export */ var transitions_TransitionExpandvue_type_script_lang_js_ = (TransitionExpandvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=484b71e6&scoped=true&lang=css&
var TransitionExpandvue_type_style_index_0_id_484b71e6_scoped_true_lang_css_ = __webpack_require__(9685);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=484b71e6&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(TransitionExpandvue_type_style_index_0_id_484b71e6_scoped_true_lang_css_/* default */.Z, options);




       /* harmony default export */ var transitions_TransitionExpandvue_type_style_index_0_id_484b71e6_scoped_true_lang_css_ = (TransitionExpandvue_type_style_index_0_id_484b71e6_scoped_true_lang_css_/* default */.Z && TransitionExpandvue_type_style_index_0_id_484b71e6_scoped_true_lang_css_/* default.locals */.Z.locals ? TransitionExpandvue_type_style_index_0_id_484b71e6_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=484b71e6&scoped=true&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  transitions_TransitionExpandvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "484b71e6",
  null
  
)

/* harmony default export */ var TransitionExpand = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,839,995,67,427], function() { return __webpack_exec__(89); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);